<template>
<v-container style="margin-top: 5%;'" max-width="100%" fluid>
    <CRUDVeiculos />
</v-container>
</template>

<script>
// @ is an alias to /src
import CRUDVeiculos from '@/components/CRUDVeiculos.vue'

export default {
  name: 'Veiculos',
  components: {
    CRUDVeiculos
  }
}
</script>